import React from 'react';
import { buoy } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Mooring',
  synonyms: 'buoy',
  group: 'standardMarker',
  typeUrl: 'mooring',
  icon: {
    baseShape: buoy,
    iconColor: '#fff',
    markerColor: '#139ECA',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-points-of-interest',
    order: 10,
  },
  standardMarkerOptions: {
    markerType: 'mooringMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Mooring',
      itemTitleFunction: (item) => (item && item.title) || 'Mooring',
    },
    creationOptions: {
      menuText: 'Mooring',
      newTitle: 'Mooring',
      titlePlaceholder: 'Name of mooring',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker is used to indicate a mooring facility available to the
          public either free of charge or for a fee.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: marker.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: false,
    title: 'Mooring',
    description:
      (marker.geoJson &&
        marker.geoJson.properties &&
        marker.geoJson.properties.description) ||
      '',
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
